import { PiralInstance } from 'piral-core';
import { shellInfo } from './shellInfo';

export const registerShellMetadata = (instance: PiralInstance): void => {
  instance.root.setData('SHELL_NAME', shellInfo.name);
  instance.root.setData('SHELL_VERSION', shellInfo.version);
};
